import { eventChannel } from 'redux-saga'
import { call, fork, put, take, cancel, cancelled } from 'redux-saga/effects'
import firebase from '../config/firebase'

import SpecialDealActions, { SpecialDealTypes } from '../reducers/specialDealReducer'

export function* getSpecialDeals() {
  try {
    const dbRef = firebase.firestore().collection('special_deals')

    const snapshot = yield call([dbRef, dbRef.get])
    const specialDeals = {}

    snapshot.forEach(doc => {
      specialDeals[doc.id] = { ...doc.data(), key: doc.id }
    })

    yield put(SpecialDealActions.setSpecialDeal(specialDeals))
    yield put(SpecialDealActions.setLoading(false))
  } catch (error) {
    yield put(SpecialDealActions.setLoading(false))
  }
}

export function* deleteSpecialDeal({ specialDealId }) {
  const dbRef = firebase
    .firestore()
    .collection('special_deals')
    .doc(specialDealId)

  try {
    yield fork([dbRef, dbRef.delete])
  } catch (error) {
    alert(error)
  }
}

const observer = ref => {
  const listener = eventChannel(emit => {
    const subscriber = ref.onSnapshot(querySnapshot => {
      const specialDeal = querySnapshot.data()
      emit({ key: querySnapshot.id, ...specialDeal })
    }, err => {
      emit(new Error(err))
    })

    return () => subscriber
  })
  return listener
}

export function* specialDealObserver(specialDealId) {
  const ref = firebase.firestore().collection('special_deals').doc(specialDealId)

  const channel = yield call(observer, ref)
  try {
    while (true) {
      const specialDeal = yield take(channel)
      yield put(SpecialDealActions.saveSpecialDeal(specialDeal))
    }
  } catch (err) {
    //
  } finally {
    if (yield cancelled()) {
      channel.close()
    }
  }
}

export function* syncSpecialDeal({ specialDealId }) {
  const specialDealListener = yield fork(specialDealObserver, specialDealId)

  yield take(SpecialDealTypes.UN_SYNC_SPECIAL_DEAL)
  yield cancel(specialDealListener)
}



// WEBPACK FOOTER //
// ./src/sagas/specialDealSaga.js